<template>
  <div class="q-pa-md">
    <q-table
      :rows="data"
      :columns="columns"
      color="primary"
      dense
      @request="handleRequest"
      class="tabela-tamanho-fixo"
      row-key="name"
      v-model:pagination="pagination"
    >
      <template #body-cell-nome="props">
        <q-td>
          {{ props.row.usuario.nome }}
        </q-td>
      </template>

      <template #body-cell-unidade="props">
        <q-td>
          {{ props.row.usuario.unidade.nome }}
        </q-td>
      </template>

      <template #body-cell-cargo="props">
        <q-td>
          {{ props.row.usuario.cargo }}
        </q-td>
      </template>

      <template #body-cell-funcao="props">
        <q-td>
          {{ props.row.usuario.funcao }}
        </q-td>
      </template>

      <template #body-cell-custo="props">
        <q-td>
          {{ props.row.usuario.centroCusto.nome }}
        </q-td>
      </template>

      <template #body-cell-dataHora="props">
        <q-td>
          {{ props.row.dataHora.split(" ")[0].split("-").reverse().join("/") }}
        </q-td>
      </template>

      <template #body-cell-Hora="props">
        <q-td>
          {{ props.row.dataHora.split(" ")[1] }}
        </q-td>
      </template>

      <template #body-cell-resposta="props">
        <q-td>
          <div class="row" v-if="props.row.resposta === 1">
            <q-icon
              class="q-ml-md"
              name="sentiment_very_dissatisfied"
              size="xl"
              color="red"
            />
          </div>

          <div class="row" v-if="props.row.resposta === 2">
            <q-icon
              class="q-ml-md"
              name="sentiment_dissatisfied"
              size="xl"
              color="orange"
            />
          </div>
          <div class="row" v-if="props.row.resposta === 3">
            <q-icon
              class="q-ml-md"
              name="sentiment_neutral"
              size="xl"
              color="yellow-5"
            />
          </div>
          <div class="row" v-if="props.row.resposta === 4">
            <q-icon
              class="q-ml-md"
              name="sentiment_satisfied"
              size="xl"
              color="blue"
            />
          </div>
          <div class="row" v-if="props.row.resposta === 5">
            <q-icon
              class="q-ml-md"
              name="sentiment_very_satisfied"
              size="xl"
              color="green"
            />
          </div>
        </q-td>
      </template>

      <template #body-cell-informacoes="props">
        <q-td>
          <q-btn
            color="primary"
            round
            class="q-ml-lg"
            icon="more_horiz"
            @click="abrirModal(props)"
          />
        </q-td>
      </template>
    </q-table>
    <q-dialog v-model="coletar">
      <q-card class="column" style="width: 800px; max-width: 80vw">
        <q-card-section class="row">
          <p class="text-h5">Dados de resposta</p>
        </q-card-section>
        <q-separator />
        <q-card-section class="row justify-around">
          <p class="text-h5">{{ nome }}</p>
          <p class="text-h6">{{ equipamento }}</p>
        </q-card-section>
        <q-card-section class="row justify-center">
          <q-input
            class="col-xs-11"
            dense
            v-model="justificativa"
            filled
            type="textarea"
            :disable="true"
          />
        </q-card-section>
        <q-separator />
        <q-card-section class="row">
          <p class="text-h5">Comentario</p>
        </q-card-section>
        <q-card-section class="row justify-center">
          <q-input
            class="col-xs-11"
            dense
            v-model="comentario"
            filled
            type="textarea"
            :disable="dasabilitar"
          />
        </q-card-section>

        <q-btn
          color="primary"
          size="md"
          text-color="white"
          label="SALVAR"
          @click="sendComentario"
          v-if="!dasabilitar"
        />
        <q-btn
          color="secondary"
          size="md"
          text-color="white"
          label="MUDAR COMENTARIO"
          @click="dasabilitar = false"
          v-if="dasabilitar"
        />
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { onMounted } from "@vue/runtime-core";
import { ref } from "@vue/reactivity";
import { watch } from "vue";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "nome",
    required: true,
    label: "Nome",
    align: "left",
    field: "nome",
    sortable: false,
  },
  {
    name: "unidade",
    align: "left",
    label: "Unidade",
    field: "unidade",
    sortable: false,
  },
  {
    name: "cargo",
    align: "left",
    label: "Cargo",
    field: "cargo",
    sortable: false,
  },
  { name: "funcao", align: "left", label: "Função", field: "funcao" },
  { name: "custo", align: "left", label: "Centro de Custo", field: "custo" },
  { name: "dataHora", align: "left", label: "Data", field: "dataHora" },
  { name: "Hora", align: "left", label: "Hora", field: "Hora" },
  { name: "resposta", align: "left", label: "Respostas", field: "resposta" },
  {
    name: "informacoes",
    align: "left",
    label: "Informações",
    field: "informacoes",
  },
];

export default {
  props: ["filtros", "atualizar"],
  setup(props) {
    const store = useStore();
    const data = ref([]);
    const filtrosList = ref("");
    const coletar = ref(false);
    const justificativa = ref("");
    const quasar = useQuasar();
    const nome = ref("");
    const equipamento = ref("");
    const comentario = ref("");
    const respostaId = ref("");
    const dasabilitar = ref(false);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getAdminHistorico = async () => {
      let resposta = await store.dispatch("cse/getHistoricoAdm");

      data.value = resposta.data.resultado.dados;

      pagination.value.rowsNumber = resposta.data.resultado.total;
      pagination.value.page = resposta.data.resultado.currentPage;
    };

    const changePagination = async (page = 1, rowsPerPage = 15) => {
      if (filtrosList.value.dataInicio != undefined) {
        filtrosList.value.dataInicio = filtrosList.value.dataInicio
          .split("/")
          .reverse()
          .join("-");
      }

      let resposta = await store.dispatch("cse/getFiltroAdm", {
        perPage: rowsPerPage,
        page: page,
        usuarioNome: filtrosList.value.nome,

        resposta: filtrosList.value.resposta,
        dataHoraInicio: filtrosList.value.dataInicio,
      });

      pagination.value.rowsPerPage = resposta.data.resultado.perPage;
      pagination.value.rowsNumber = resposta.data.resultado.total;
      pagination.value.page = resposta.data.resultado.currentPage;

      data.value = resposta.data.resultado.dados;
    };

    const handleRequest = async (props) => {
      changePagination(props.pagination.page, props.pagination.rowsPerPage);
    };

    const abrirModal = async (props) => {
      coletar.value = true;
      comentario.value = "";
      justificativa.value = props.row.justificativa;
      nome.value = props.row.usuario.nome;
      equipamento.value = props.row.equipamento;
      respostaId.value = props.row.resposta_id;
      if (props.row.observacao != null) {
        comentario.value = props.row.observacao.observacao;
        dasabilitar.value = true;
        return;
      }
      dasabilitar.value = false;
    };

    const sendComentario = async () => {
      try {
        await store.dispatch("cse/sendComentario", {
          observacao: comentario.value,
          respostaId: respostaId.value,
        });
        coletar.value = false;

        quasar.notify({
          message: "Comentario enviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getAdminHistorico();
      } catch (error) {
        quasar.notify({
          message: "Erro ao enviar comentario",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getAdminHistorico);

    watch(
      () => props.atualizar,
      () => {
        filtrosList.value = props.filtros;
        changePagination();
      }
    );

    return {
      columns,
      getAdminHistorico,
      data,
      pagination,
      changePagination,
      handleRequest,
      filtrosList,
      abrirModal,
      coletar,
      justificativa,
      nome,
      equipamento,
      comentario,
      sendComentario,
      respostaId,
      dasabilitar,
    };
  },
};
</script>
